import './polyfill';
import { ErrorBoundary } from 'components/error/ErrorBoundary';
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from '@locus.sh/neo';
import App from './pages/App';
import './i18n';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import EnvConfig from 'config';
import Rum from 'helpers/Rum';

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);

Rum.init({
    ...EnvConfig.groundcover,
    appId: 'viash',
    // eslint-disable-next-line no-undef
    environment: __BUILD_ENV__,
    // eslint-disable-next-line no-undef
    releaseId: __VERSION__,
});

const title = 'via.sh';

ReactDOM.render(
    <ThemeProvider>
        <ErrorBoundary>
            <App title={title} />
        </ErrorBoundary>
    </ThemeProvider>,
    document.getElementById('app')
);

if (module.hot) {
    module.hot.accept();
}
